// Les timestamps SQL renvoyés sans suffixe par Laravel sont enregistrés en UTC.
// Les dates civiles (YYYY-MM-DD) et les saisies locales (datetime-local) gardent
// leur interprétation habituelle ; seuls les horodatages SQL sont normalisés.
export function parseBackendTimestamp(value) {
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}(?::\d{2}(?:\.\d+)?)?$/.test(value.trim())) {
        return new Date(value.trim().replace(' ', 'T') + 'Z')
    }
    return new Date(value)
}
